import { render, staticRenderFns } from "./AdjustmentsCutOff.vue?vue&type=template&id=1854015b&scoped=true"
import script from "./AdjustmentsCutOff.vue?vue&type=script&lang=js"
export * from "./AdjustmentsCutOff.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentsCutOff.vue?vue&type=style&index=0&id=1854015b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854015b",
  null
  
)

export default component.exports